import React, { useEffect } from 'react';
import { X } from 'lucide-react';
import CompanyForm from './CompanyForm';

interface AddCompanyPopupProps {
  onClose: () => void;
  onSuccess: () => void;
}

export default function AddCompanyPopup({ onClose, onSuccess }: AddCompanyPopupProps) {
  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [onClose]);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4">
      <div className="bg-dark-800 rounded-lg max-w-2xl w-full p-6">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-xl font-semibold">Add Company</h2>
          <button 
            onClick={onClose}
            className="text-gray-400 hover:text-white"
          >
            <X className="w-6 h-6" />
          </button>
        </div>

        <CompanyForm
          onSuccess={onSuccess}
          onCancel={onClose}
        />
      </div>
    </div>
  );
}